export default function ClockIcon() {
  return (
    <>
      <path
        d='M14.6693 8.50065C14.6693 12.1807 11.6826 15.1673 8.0026 15.1673C4.3226 15.1673 1.33594 12.1807 1.33594 8.50065C1.33594 4.82065 4.3226 1.83398 8.0026 1.83398C11.6826 1.83398 14.6693 4.82065 14.6693 8.50065Z'
        stroke='#38383A'
        strokeWidth='1.47473'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.47 10.6192L8.40333 9.38586C8.04333 9.17253 7.75 8.65919 7.75 8.23919V5.50586'
        stroke='#38383A'
        strokeWidth='1.47473'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </>
  );
}
